import styled from 'styled-components';

export const Contain = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;

  @media (max-width: 1152px) {
    padding: 0 1rem;
  }

  @media (min-width: 50rem) {
    ${props => props.small && `
      max-width: 1024px;
    `}

    ${props => props.smallContent && `
      max-width: 50rem;
    `}

    ${props => props.grid && `
      display: grid;
      grid-template-columns: .5fr .5fr;
    `}

    ${props => props.gridCenter && `
      align-items: center;
    `}

    ${props => props.flexCenterBetween && `
      display: flex;
      align-items: center;
      justify-content: space-between;
    `}
  }

  ${props => props.textCenter && `
    text-align: center;
  `}

  ${props => props.extraSmall && `
    max-width: 50rem;
    padding: 0 2rem;
    position: relative;
  `}

  ${props => props.fullWidth && `
    max-width: 100%;
    padding: 0 2rem;
  `}

  ${props => props.column && `
    flex-direction: column;
  `}
`;
